import { Helmet } from "react-helmet-async";
import GlobalVar from "utils/config";

export const VolumeSEO = ({ volume, issue, articles }) => {
  const journalTitle = "Journal of Transportation Science and Technology";
  const siteUrl = process.env.NODE_ENV === 'production' ? "https://jtst.ut.edu.vn" : GlobalVar.FRONTEND_URI;
  
  const title = issue ? 
    `${volume?.name || ''} ${issue?.name || ''} - ${journalTitle}` :
    `${volume?.name || 'Articles in Press'} - ${journalTitle}`;
    
  const description = issue ? 
    `Articles published in ${volume?.name || ''} ${issue?.name || ''} of ${journalTitle}` :
    `Articles in press for ${journalTitle}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      
      {/* For articles in this issue/volume */}
      {articles && articles.map((article, index) => (
        <link key={index} rel="alternate" type="application/pdf" 
              href={`${siteUrl}/articles/${article._id}/download`} 
              title={article.info?.title} />
      ))}
      
      {/* Canonical URL */}
      <link rel="canonical" href={issue ? 
        `${siteUrl}/volumes-and-issues/${issue._id}` : 
        `${siteUrl}/volumes-and-issues/0`} />
    </Helmet>
  );
};
